import TextTruncate from './TextTruncate';
import './text-truncate.scss';

export default TextTruncate;
